
export type IBooleanString = "true" | "false"

export type IBranch = string | "master" | "canary" | "main"
